import styled from 'styled-components';

import { Z_INDEX_HIGHEST } from '@mews-ui/theme';

export interface TargetWrapperElementProps {
    disablePointerEvents?: boolean;
}

export const TargetWrapperElement = styled.div<TargetWrapperElementProps>`
    z-index: ${Z_INDEX_HIGHEST};
    ${(props) => props.disablePointerEvents && 'pointer-events: none;'}
`;
